import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import CloseIcon from '@mui/icons-material/Close'

export const BootstrapDialogTitle = ({ children, onClose, ...other }) => (
  <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
    {children}
    {onClose ? (
      <IconButton
        aria-label="close"
        data-testid="modal-close-button"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 12,
          color: theme => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    ) : null}
  </DialogTitle>
)

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
}

const DialogModal = ({
  title,
  buttonTitle,
  secondaryButtonTitle,
  saveButtonProps,
  isLoading,
  open,
  closeVisible,
  extraAction,
  onSave,
  onClose,
  children,
  hideDialogActions,
  hideDividers,
  hideTitle,
  saveDisabled,
  dialogStyles,
  ...restProps
}) => (
  <Dialog
    sx={{
      '& .MuiDialog-paper': { width: '100%', maxWidth: 990 },
      ...dialogStyles,
    }}
    onClose={onClose}
    aria-labelledby="customized-dialog-title"
    open={open}
    {...restProps}
  >
    {!hideTitle && (
      <BootstrapDialogTitle id="customized-dialog-title" onClose={onClose}>
        {title}
      </BootstrapDialogTitle>
    )}
    <DialogContent dividers={!hideDividers}>{children}</DialogContent>
    {!hideDialogActions && (
      <DialogActions>
        {closeVisible && (
          <Button autoFocus data-testid="modal-cancel-button" onClick={onClose}>
            {secondaryButtonTitle}
          </Button>
        )}
        {extraAction.text && (
          <Button variant="outlined" data-testid="modal-extra-action-button" {...extraAction}>
            {extraAction.text}
          </Button>
        )}
        <LoadingButton
          variant="contained"
          data-testid="modal-save-button"
          disabled={saveDisabled}
          onClick={onSave}
          loading={isLoading}
          {...saveButtonProps}
        >
          {buttonTitle}
        </LoadingButton>
      </DialogActions>
    )}
  </Dialog>
)

DialogModal.propTypes = {
  title: PropTypes.string,
  buttonTitle: PropTypes.string,
  secondaryButtonTitle: PropTypes.string,
  saveButtonProps: PropTypes.object,
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  closeVisible: PropTypes.bool,
  extraAction: PropTypes.object,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  hideDialogActions: PropTypes.bool,
  hideDividers: PropTypes.bool,
  hideTitle: PropTypes.bool,
  saveDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  dialogStyles: PropTypes.object,
}

DialogModal.defaultProps = {
  title: '',
  buttonTitle: 'Save',
  secondaryButtonTitle: 'Cancel',
  saveButtonProps: {},
  children: undefined,
  closeVisible: true,
  extraAction: {},
  hideDialogActions: false,
  onSave: () => {},
  onClose: () => {},
  hideDividers: false,
  hideTitle: false,
  saveDisabled: false,
  isLoading: false,
  dialogStyles: {},
}

export default DialogModal
